import { NotificationType } from '@copilot/common/store/models/const/enum';
import { SidebarNotificationMap } from './sideBarTypes';

/**
 * Default sidebar notifications
 */
export const DEFAULT_SIDEBAR_NOTIFICATIONS: SidebarNotificationMap = Object.values(
    NotificationType
).reduce((acc, key) => ({ ...acc, [key]: 0 }), {} as SidebarNotificationMap);
